import {
    GetStateResponse,
    PostDocumentUploadResponse
} from '@iwoca/lapi-client/edge';

import { CHOOSE_DOCUMENT_TYPE } from './chooseDocumentType/ChooseDocumentType.actions';
import { DOCUMENT_UPLOADER } from './documentUploader/DocumentUploader.actions';
import {
    ADD_TO_DOCUMENT_PENDING_LIST,
    UPDATE_DOCUMENT_STATUS_ON_COMPLETED,
    UPDATE_DOCUMENT_STATUS_ON_ERROR
} from './UploadDocumentsModal.actions';
import {
    TDocumentTypes,
    getDocumentTypes,
    updateDocumentStatusOnCompleted,
    updateDocumentStatusOnError
} from './UploadDocumentsModalHelper';
import { mergeStates } from '../../../iwProvider/StoreHelper';

const initialState: TState = {
    documentType: null,
    documentData: {},
    documentsStatus: []
};

type TState = {
    documentType: {
        label: string;
        value: string;
    } | null;
    documentsStatus: TDocument[] | [];
    documentTypes?: TDocumentTypes;
    documentData: { numberOfBankStatementsInMonths?: number };
    preventBackNavigation?: boolean;
    feedbackIds?: number[] | null;
    applicationId?: string;
};

export type TDocument = {
    type: { label: string; value: string };
    name?: string;
    pending?: boolean;
    success?: boolean;
    error?: boolean;
    code?: string;
};

type TAction =
    | {
          type: typeof UPDATE_DOCUMENT_STATUS_ON_ERROR;
          deserialisedErrorResponse: {
              errorCode: string;
              document: File;
              resolvedDocument: { name: string };
          };
      }
    | {
          type: typeof UPDATE_DOCUMENT_STATUS_ON_COMPLETED;
          successResponse: PostDocumentUploadResponse;
      }
    | {
          type: typeof ADD_TO_DOCUMENT_PENDING_LIST;
          document: TDocument;
      }
    | { type: typeof CHOOSE_DOCUMENT_TYPE; customer_state: GetStateResponse }
    | {
          type: typeof DOCUMENT_UPLOADER;
          preventBackNavigation: boolean;
          documentType: {
              label: string;
              value: string;
          };
          documentData: {
              numberOfBankStatementsInMonths?: number;
          };
          feedbackIds?: number[] | null;
          applicationId?: string;
      };

// eslint-disable-next-line import/no-default-export
export default function (
    state: TState = initialState,
    action: TAction
): TState {
    switch (action?.type) {
        case UPDATE_DOCUMENT_STATUS_ON_ERROR:
            return mergeStates(state, {
                documentsStatus: updateDocumentStatusOnError(
                    state.documentsStatus,
                    action
                )
            });

        case UPDATE_DOCUMENT_STATUS_ON_COMPLETED:
            return mergeStates(state, {
                documentsStatus: updateDocumentStatusOnCompleted(
                    state.documentsStatus,
                    action
                )
            });

        case ADD_TO_DOCUMENT_PENDING_LIST:
            return mergeStates(state, {
                // @ts-expect-error Not sure why but concat seems to be expecting an argument of never
                documentsStatus: state.documentsStatus.concat([action.document])
            });

        case CHOOSE_DOCUMENT_TYPE:
            return mergeStates(state, {
                documentType: null,
                documentTypes: getDocumentTypes(action.customer_state)
            });

        case DOCUMENT_UPLOADER:
            return {
                preventBackNavigation: action.preventBackNavigation,
                documentType: action.documentType,
                documentData: action.documentData || {},
                documentsStatus: [],
                feedbackIds: action.feedbackIds || null,
                applicationId: action.applicationId
            };

        default:
            return state;
    }
}
